﻿import * as React from "react";
import {
    IBaseSubSectionProps,
    SmartBoardsSubSection,
    ToolMenuSubSection,
} from "./";
import { IMenuSectionProps } from "../Sections";

export class SubSectionLoader {
    private readonly _context: Readonly<IMenuSectionProps>;

    private readonly _bindSubSection: (subSectionId: number) => void;

    constructor(
        context: Readonly<IMenuSectionProps>,
        bindSubSection: (subSectionId: number) => void,
    ) {
        this._context = context;
        this._bindSubSection = bindSubSection;
    }

    public getSubSection(
        props: IBaseSubSectionProps,
        isActive: boolean,
    ): React.ReactNode {
        switch (props.type) {
            case `ToolMenu`:
                return this._toolMenu(props, isActive, ``);
            case `SmartBoardManager`:
                return this._smartBoards(props, isActive, ``);
            default:
                return null;
        }
    }

    public getFilteredSubSection(
        props: IBaseSubSectionProps,
        searchQuery: string,
    ): React.ReactNode {
        switch (props.type) {
            case `ToolMenu`:
                return this._toolMenu(props, true, searchQuery);
            case `SmartBoardManager`:
                return this._smartBoards(props, true, searchQuery);
            default:
                return null;
        }
    }

    private _toolMenu(
        props: IBaseSubSectionProps,
        isActive: boolean,
        searchQuery: string,
    ): React.ReactNode {
        return (
            <ToolMenuSubSection
                bindSubSection={this._bindSubSection}
                bindToolToFrame={this._context.bindToolToFrame}
                isActive={isActive}
                key={props.id}
                searchQuery={searchQuery}
                {...props}
            />
        );
    }

    private _smartBoards(
        props: IBaseSubSectionProps,
        isActive: boolean,
        searchQuery: string,
    ): React.ReactNode {
        return (
            <SmartBoardsSubSection
                bindSubSection={this._bindSubSection}
                bindToolToFrame={this._context.bindToolToFrame}
                isActive={true}
                key={props.id}
                searchQuery={searchQuery}
                {...props}
            />
        );
    }
}
